import React from 'react'
import clsx from 'clsx'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button-v1'

import styles from './AboutAssessmentSection.module.css'
import { useAuth } from 'utils/auth'
import { useAPIJenjangSelection } from 'api/assessment/useAPIJenjangSelection'

import ImgAssessmentIndicator from 'assets/images/assessment/img-assessment-indicator.svg'

interface AboutAssessmentSectionProps {
  onShowSheet?: () => void
}

const AboutAssessmentSection = ({
  onShowSheet,
}: AboutAssessmentSectionProps) => {
  const { session } = useAuth()
  const router = useRouter()
  const userEmail = session?.user?.email || null
  const { data: jenjangSelections } = useAPIJenjangSelection()
  const userJenjang = jenjangSelections?.reduce((acc, jenjang) => {
    if (userEmail?.includes(jenjang.identifier)) {
      return jenjang.label
    }
    return acc
  }, null)

  const onBannerClicked = () => {
    if (userJenjang) {
      const url = jenjangSelections?.find(
        (jenjang) => jenjang.label === userJenjang
      )?.url

      if (url) {
        router.push(url)
      }

      return
    }
    onShowSheet?.()
  }
  return (
    <div className="px-4 py-6">
      <Text color="inverse" variant="heading-md" className="mb-4">
        Tentang Asesmen
      </Text>
      <div
        className={clsx(
          'rounded-md px-4 py-3 flex bg-white cursor-pointer',
          styles.aboutAssessmentSection
        )}
        onClick={onBannerClicked}
      >
        <div className="flex-1">
          <Text className="!font-semibold mb-1">Tentang asesmen</Text>
          <Text className="mb-2">Pelajari asesmen lebih lanjut</Text>
          <Button className="!rounded-full">Mulai Belajar</Button>
        </div>
        <div className="flex justify-center items-center">
          <ImgAssessmentIndicator className="w-[90px] h-[90px]" />
        </div>
      </div>
    </div>
  )
}

export default AboutAssessmentSection
